export const maintenanceFeeEndpoints = (builder) => ({ 
    searchAccounts: builder.query({
        query: (query) => {
            return { url: `/users/accounts?query=${query}`, method: 'get' };
        },
        providesTags: ['Maintenance Fee'],
    }),
    
    
    createMaintenanceFee: builder.mutation({
        query: (data) => ({url: `/maintenance-fee`, method: 'post', body: data}),
        invalidatesTags: ['Maintenance Fee'],
    }),
    createBilling: builder.mutation({
        query: (data) => ({url: `/maintenance-fee/bill`, method: 'post', body: data}),
        invalidatesTags: ['Maintenance Fee'],
    }),
    getBillingHistory: builder.query({
        query: () => ({ url: `/maintenance-fee/bill`, method: 'get' }),
        providesTags: ['Maintenance Fee'],
    }),
    exemptAccounts: builder.mutation({
        query: ({ accounts, fields,  userGroup   }) => {
            const Body = { accounts, fields, userGroup };
    
            return {
                url: `/maintenance-fee/exempt-accounts`,
                method: 'post',
                body: Body,
            };
        },
        invalidatesTags: ['Maintenance Fee']
    }),
    getMaintenanceFeeSettings: builder.query({
        query: (partner) => ({ url: `/maintenance-fee/settings/${partner}`, method: 'get' }),
        providesTags: ['Maintenance Fee'],
    }),
    processBillings: builder.mutation({
        query: (autoId) => ({ url: `/maintenance-fee/process/${autoId}`, method: 'post' }),
        invalidatesTags: ['Bonus Shares']
    }),
})